import React, {FC, lazy, Suspense} from 'react';
import {Metric, Result} from 'templates/reports/Section/RegionalComp/parse';

import {Table} from './Table';

import * as styles from './styles.module.scss';

const LazyChart = lazy(() => import('templates/reports/Section/RegionalComp/Snapshot/Charts/Pies/Chart'));

const DynamicChart: FC<PiesProps> = (props) => (
	<Suspense fallback={null}>
		<LazyChart {...props} />
	</Suspense>
);

type PiesProps = {
	metric: Metric
	result: Result
}

const title = (metric: Metric) => {
	switch (metric) {
	case 'bone':
		return 'Bone mineral (grams)';

	}
	return metric[0].toUpperCase() +
		metric.slice(1) + ' mass (lbs)';
};

export const Pies: FC<PiesProps> = (props) => {
	const {metric} = props;
	return (
		<div className={styles.bars}>
			<h3>{title(metric)}</h3>
			<h4>
				<span>
					The three rings represent the 10th, 50th, and 90th
					percentiles of proportionality. Areas closer to
					the outer ring are proportionally larger than average.
				</span>
			</h4>
			<DynamicChart {...props} />
			<Table {...props} />
		</div>
	);
};
